export const Info = ({ message, small, style, children }) => {
  if (!message && !children) return null;
  return (
    <div
      style={{
        border: small ? '' : '0px solid #2b6cb0',
        background: small ? '' : '#e4eef8',
        padding: small ? null : '10px 15px',
        fontSize: small ? 12 : 14,
        margin: '4px 0',
        color: '#2b6cb0',
        fontWeight: 'bold',
        borderRadius: 4,
        ...style,
      }}
    >
      {children}
      {typeof message === 'string' ? message : JSON.stringify(message)}
    </div>
  );
};
